import { combineReducers } from '@reduxjs/toolkit';
import chatReducer from '@/store/reducers/chat.reducer';

const rootReducer = combineReducers({
  chat: chatReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
